class Customer.Dashboard.TicketNewEmailTextView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/new_ticket_text']

  events:
    'click .send_response'            : '_onSend'
    'click .send_response_and_close'  : '_onSendAndClose'
    'click #btn-new-email-cancel'     : '_onCancel'
    'click #btn-new-email-preansw'    : '_onPredefinedTemplates'
    'change #social_accounts'         : '_onChangeSocialAccount'

  initialize: (@options = {}) ->
    @ticketView = @options.ticketView
    @socialAccounts = @options.enabledEmailSocialAccounts
    @defaultEmailSubjectBySocialAccountEmail = @options.defaultEmailSubjectBySocialAccountEmail
    @subjectLimit = @options.subjectLimit || 500
    @emailText = @_automaticSignature()

  render: ->
    @_renderTemplate()
    @_renderEditor()
    @_renderAttachments()
    @_onChangeSocialAccount()
    @

  onAttach: ->
    @_renderEditor()

  onDetach: ->
    @editor?.depose()

  focus: ->
    @editor.focus()

  onSendError: ->
    @toggleSendButton(true)

  toggleSendButton: (enabled)->
    @$el.find('#social_accounts').prop('disabled', !enabled)
    @$el.find('#input_send_to').prop('disabled', !enabled)
    @$el.find('#show-with-copy').prop('disabled', !enabled)
    @$el.find('#show-with-hidden-copy').prop('disabled', !enabled)
    @$el.find('#input_subject').prop('disabled', !enabled)
    @$el.find('#icon-signatures').prop('disabled', !enabled)
    @$el.find('#add-attachment').prop('disabled', !enabled)
    @$el.find('#btn-new-email-preansw').prop('disabled', !enabled)
    @$el.find('#btn-new-email-cancel').prop('disabled', !enabled)
    if enabled
      @$el.find('#new-email-send').show()
      @$el.find('#new-email-send-disabled').hide()
      @editor.editor.enable()
    else
      @$el.find('#new-email-send').hide()
      @$el.find('#new-email-send-disabled').show()
      @editor.editor.disable()

  showAttachmentRow: =>
    @$el.find('#attachment-row').show()

  hideAttachmentRow: =>
    files = @attachment.allFiles()
    @$el.find('#attachment-row').hide() if files.length == 0

  availablesSignatures: =>
    @ticketView.getSignatures().signaturesForNewTicket('email', (signatures) =>
      return signatures
    )


  _onChangeSocialAccount: =>
    email = @$el.find('#social_accounts :selected').data('email')
    defaultSubject = @defaultEmailSubjectBySocialAccountEmail[email]
    @$el.find('#input_subject').val(defaultSubject) if defaultSubject
    true

  _renderTemplate: ->
    @$el.html(@template())
    @emailTextDetails = new Customer.Dashboard.EmailTextDetailsView(
      mainTextView: @,
      subjectLimit: @subjectLimit,
      socialAccounts: @socialAccounts,
      validateSubject: true
    )
    @emailTextExtraActions = new Customer.Dashboard.EmailTextExtraActionsView(
      notes: false,
      schedule: false
    )
    @listenTo(@emailTextExtraActions, 'email:action:add:signature', @_onSignatures)
    @listenTo(@emailTextExtraActions, 'email:action:add:attachment', @_onAddAttachment)
    @$el.find('#new-email-extra-actions').html(@emailTextExtraActions.render().el)
    @$el.find('#email-detail-box').html(@emailTextDetails.render().el)

  _renderEditor: ->
    @emailTextContainer = @$el.find("#enriched-text-box")
    @editor = HtmlEditorView.create(@emailTextContainer, @_editorOptions())
    @listenTo(@editor, 'editor:htmltext:textChanged', @_keepCustomerSessionAlive)
    @editor.render()

  _renderAttachments: ->
    @attachmentsContainer = @$el.find('#attachments-container.attachment-uploader')
    @attachment = new Customer.Ticket.ResponseAttachmentView(@attachmentsContainer, @, 'email')
    @listenTo @attachment, 'add:attachment', @showAttachmentRow
    @listenTo @attachment, 'remove:attachment', @hideAttachmentRow
    @attachment.render()
    @$el.find('#attachments-container.attachment-uploader label#add-direct-attachment-file-btn').hide()
    @$el.find('#attachments-container.attachment-uploader .attachments-title').removeClass('hidden')

  _editorOptions: ->
    if @editor != undefined
      text = @_replacedEditorText()
    else
      text = @emailText
    text: text
    height: 300

  _replacedEditorText: ->
    # we are replacing <div>&nbsp;</div> to <br>, because @editor ignores empty <div's> and empty <p's>
    # <p> elements are automatically replaced to <div> elements by the @editor
    replace_regex = /<div>(&nbsp;)*<\/div>/g
    @editor.getPlainHTML().replace(replace_regex, '<br>').replace(/&nbsp;/g, " ")

  _automaticSignature: ->
    signatures = @availablesSignatures()
    signature = _.first signatures if signatures.length == 1
    signature.get('text_html') if signature?.get('append_to_new_ticket')

  _setResponseTemplateText: (text) ->
    @editor.insertHTMLTextAtCursor(text)

  _responseTemplateParams: ->
    labels: []
    tags: []
    typeForResponseTemplates: 'email'

  _sendParameters: ->
    invalidAttributes = @emailTextDetails.validateAttributes()
    try
      @_updateText()
    catch exception
      @$el.find('#enriched-text-box').addClass('validation_error')
      invalidAttributes.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.response'))
    if invalidAttributes.length > 0
      @_showInvalidAttributesSwal(invalidAttributes)
      return false
    else
      {
        social_account_id: @emailTextDetails.getSocialAccount()
        to_email: @emailTextDetails.getEmailTo().trim()
        to_cc_email: @emailTextDetails.getCC().join(',') || ""
        to_cco_email: @emailTextDetails.getCCo().join(',') || ""
        subject: @emailTextDetails.getSubject()
        response_html: @emailText
        response: @_textWithoutHTML(@emailText)
        type: 'email'
        attachments: if @attachment then @attachment.toJSON() else []
      }

  _sendAndCloseParameters: ->
    params = @_sendParameters()
    return false unless params

    params.close = true
    params

  _textWithoutHTML: (html_text) ->
    tempDiv = document.createElement("div")
    tempDiv.innerHTML = html_text
    return tempDiv.textContent || tempDiv.innerText || ""

  _updateText: =>
    @editor.update()
    final_html_text = @_replacedEditorText()
    @emailText = final_html_text

  _onAddAttachment: ->
    @_showUploadAttachmentText()
    button = @$el.find('#attachments-container.attachment-uploader label#add-direct-attachment-file-btn')
    button.click()

  _onToggleEmojis: =>
    @editor.textareaElement().emojiPicker('toggle')
    container = @emailTextContainer[0].getBoundingClientRect()
    $('.emojiPicker').offset({top: container.top, left: container.right })
    false

  _onSignatures: =>
    singaturesCollection = @ticketView.getSignatures().signaturesFor('email', [], (signature) =>
      if signature == ''
        @emailTextExtraActions.noSignatureTooltip()
      else
        @editor.insertHTMLTextAtCursor(signature)
    )

  _onPredefinedTemplates: ->
    @_keepCustomerSessionAlive()
    new Customer.ResponseTemplateSelectView
      ticketId: ''
      params: @_responseTemplateParams()
      onSelect: (text) => @_setResponseTemplateText(text)

  _onCancel: ->
    @_keepCustomerSessionAlive()
    @trigger('press:cancel')

  _onSend: ->
    @_keepCustomerSessionAlive()
    @toggleSendButton(false)
    params = @_sendParameters()
    if params
      @ticketView.onSend(params)
    else
      @onSendError()

  _onSendAndClose: ->
    @_keepCustomerSessionAlive()
    @toggleSendButton(false)
    @_showSendingText()
    params = @_sendAndCloseParameters()
    if params
      @ticketView.onSend(params)
    else
      @onSendError()

  _showInvalidAttributesSwal: (errors) ->
    error_text = "#{I18n.t('customer.dashboard.new_case.modal.validation_error')}:\n"
    _.each(errors, (error) =>
      error_text = error_text.concat "\n #{error}"
    )
    swal(
      I18n.t('customer.dashboard.new_case.modal.validation'),
      error_text,
      'error'
    )

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _showSendingText: =>
    @$el.find("#spinner-text-sending").show()
    @$el.find("#spinner-text-upload-attachment").hide()

  _showUploadAttachmentText: =>
    @$el.find("#spinner-text-sending").hide()
    @$el.find("#spinner-text-upload-attachment").show()
